module.exports = __webpack_public_path__ + "h5/img/touzi.4fc1f469.png";